import css from 'styled-jsx/css';
import {
  colorHighlight,
  display,
  pageWidth,
  sansSerif,
  serif,
  colorPalette
} from 'styles/css-constants';
import { uppercase } from 'styles/typography/css-mixins';

export default css`
  .PersonProfile {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 0.5rem;
  }

  .PersonProfile.PersonProfile--grid {
    flex-direction: column;
    align-items: center;
  }

  .PersonProfile__bio {
    margin: 1rem 0;
    font-family: ${serif};
    font-size: var(--baseFontSize);
    line-height: 1.55;
  }

  .PersonProfile__bio :global(a) {
    border-bottom: 1px solid ${colorHighlight};
    color: inherit;
  }

  .PersonProfile__image {
    margin-bottom: 1rem;
    width: 75%;
    border-radius: 50%;
    overflow: hidden;
  }

  .PersonProfile__image :global(img) {
    width: 100%;
  }

  .PersonProfile.PersonProfile--grid .PersonProfile__image {
    width: 100%;
    margin-right: 0;
  }

  .PersonProfile.PersonProfile--grid .PersonProfile__info {
    color: ${colorPalette.gray};
  }

  .PersonProfile.PersonProfile--grid .PersonProfile__name {
    ${uppercase}
    font-size: var(--fontScale1);
    color: ${colorHighlight};
    font-family: ${sansSerif};
    margin-top: 1rem;
  }

  .PersonProfile.PersonProfile--grid .PersonProfile__name,
  .PersonProfile.PersonProfile--grid .PersonProfile__title {
    font-weight: normal;
  }

  .PersonProfile__info {
    text-align: center;
  }

  .PersonProfile__links {
    display: flex;
    justify-content: center;
    list-style: none;
  }

  .PersonProfile__links li {
    margin: 0 0.25rem;
    width: 2rem;
    height: 2rem;
  }

  .PersonProfile__location {
    font-size: var(--fontScaleNeg2);
  }

  .PersonProfile__name {
    margin-bottom: 0.25rem;
    font-family: ${display};
    font-size: var(--fontScale5);
  }

  .PersonProfile__title {
    margin-bottom: 0.25rem;
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg1);
    font-weight: bold;
  }

  @media (min-width: 48rem) {
    .PersonProfile {
      padding: 0 1.5rem;
      flex-direction: row;
      align-items: flex-end;
    }

    .PersonProfile__image {
      margin-bottom: 0;
      margin-right: 1.5rem;
      flex: 0 0 33.33%;
      width: 33.33%;
    }

    .PersonProfile__info {
      text-align: left;
    }

    .PersonProfile.PersonProfile--grid .PersonProfile__info {
      text-align: center;
    }

    .PersonProfile__links {
      justify-content: flex-start;
    }

    .PersonProfile__links li {
      margin: 0 0.5rem 0 0;
    }
  }

  @media (min-width: 64em) {
    .PersonProfile {
      margin: 0 auto;
      max-width: ${pageWidth.large};
      padding: 0;
    }

    .PersonProfile__image {
      flex: 0 0 20%;
      width: 20%;
    }

    .PersonProfile__info {
      /* keep line lengths reasonable */
      max-width: 800px;
    }

    .PersonProfile__location {
      font-size: var(--fontScaleNeg1);
    }

    .PersonProfile__name {
      font-size: var(--fontScale4);
    }

    .PersonProfile__title {
      font-size: var(--baseFontSize);
    }
  }

  @media (min-width: 75em) {
    .PersonProfile {
      max-width: ${pageWidth.midlarge};
    }
  }
`;
